import styles from './SelectSeparator.module.css';

export function SelectSeparator() {
  return <hr className={styles.SelectSeparator} />;
}
